export default __webpack_public_path__ + "static/media/bataan.ff495e0a.jpg";